import { ModuleBase } from "./ModuleBase";

export function addMetadata(obj, state) {
	//Extension of serialization in order to store custom data.
	obj.toObject = (function(toObject) {
		return function() {
			return fabric.util.object.extend(toObject.call(this), {
				moduleName: this.moduleName,
				moduleState: this.moduleState
			});
		};
	})(obj.toObject);

	obj.moduleName = obj.moduleName || "unknownModule";
	obj.moduleState = state;

	return obj;
}

export class StatefulModule extends ModuleBase {
	addMetadata(obj, state) {
		obj.moduleName = this.constructor.name;
		return addMetadata(obj, state);
	}

	get canvas() {
		return this._canvas;
	}
	set canvas(c) {
		this._canvas = c;
		//this is only needed for the modules with settings popup
		//we want to do this only once during bootstrap stage
		this._canvas.configurableModules = this._canvas.configurableModules || {};
		this._canvas.configurableModules[this._moduleName] = this;
	}

	_getSettingsHeader() {
		const capitalizedName =  (typeof this.name === 'string' && this.name.length > 1)
			? this.name[0].toUpperCase() + this.name.substring(1)
			: 'Shape'
		return capitalizedName + ' settings';
	}
    
	get transpColor() {
		return 'transparent';
	}
    
	get inputTranspColor() {
		return '#ffffff';
	}

	constructor() {
		super();
		this._moduleName = this.constructor.name;
	}
}
